import * as RadixContextMenu from '@radix-ui/react-context-menu';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ContextMenuRadioGroupProps = RadixContextMenu.ContextMenuRadioGroupProps;

export const ContextMenuRadioGroup = memo(({ className, ...restOfProps }: ContextMenuRadioGroupProps) => {
  return <RadixContextMenu.RadioGroup className={cn('flex flex-col gap-2', className)} {...restOfProps} />;
});

ContextMenuRadioGroup.displayName = 'ContextMenuRadioGroup';
